import React, { Component } from 'react';
import Checkbox from '@mui/material/Checkbox';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MaterialTable from '@material-table/core';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import mainStore from '../../../MainStore';
import Participants from './Participants';
import { observer } from 'mobx-react';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import EnvironmentProductTable from './EnvironmentProductTable';

const ProjectEnvironments = observer(class ProjectEnvironments extends Component {
    constructor() {
        super();
        this.state = {
            projectInfo: {
                isCodeReviewOn: false,
                checkedA: 'checkedA',
                planHours: 0
            },
            environmentColumns: [
                { title: 'Имя', field: 'name' },
                { title: 'Адрес', field: 'url' },
                { title: 'Тип', field: 'environmentType', lookup: {}, defaultGroupOrder: 0 },
                { title: 'Redis db', field: 'redisDB', lookup: {} },
                { title: 'SQL server', field: 'sqlServer', lookup: {} },
                { title: 'SQL DB', field: 'sqlDB' },
            ],
            environments: [],
            environmentTypes: [],
            redisDBS: [],
            sqlServers: [],

            isAddEnvironmentOpen: false,
            rowData: {
                binPath: '',
                sqlDB: '',
                name: '',
                environmentType: '',
                sqlServer: '',
                redisDB: '',
                id: ''
            },
            selectedTab: 0
        };
        this.load = this.load.bind(this);
        this.addEnvironment = this.addEnvironment.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleRowDataChange = this.handleRowDataChange.bind(this);
    };

    componentDidMount() {
        this.load();
    };

    componentDidUpdate(prevProps) {
        if (prevProps && prevProps.project.id !== this.props.project.id) {
            this.load();
        }
    };

    handleTabChange(event, newValue) {
        this.setState({ "selectedTab": newValue });
    }

    handleRowDataChange = name => evt => {
        var rowData = this.state.rowData;
        rowData[name] = evt.target.value;
        this.setState({ rowData: rowData });
    };

    handleChange = name => evt => {
        mainStore.openedProject[name] = evt.target.value;
        mainStore.setOpenedProject(mainStore.openedProject);
    };

    handleClose() {
        this.setState({ "isAddEnvironmentOpen": false });
    }

    load() {
        mainStore.setMaskVisible();
        var scope = this;

        fetch('api/Environment/GetProjectEnvironmentsInfo?projectId=' + this.props.project.id, {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    //scope.setState({ projectInfo: result, isLoading: false });
                    var envColumns = scope.state.environmentColumns;
                    result.environmentTypes.forEach(t => { envColumns[2].lookup[t.id] = t.name; });
                    result.redisDBS.forEach(t => { envColumns[3].lookup[t.id] = t.name; });
                    result.sqlServers.forEach(t => { envColumns[4].lookup[t.id] = t.name; });
                    scope.setState({ "environmentColumns": envColumns, "environments": result.environments, environmentTypes: result.environmentTypes, redisDBS: result.redisDBS, sqlServers: result.sqlServers });
                    mainStore.setMaskUnvisible();
                }).catch((err) => console.log(err));
            }
        });
    };

    handleSave() {
        var scope = this;
        fetch('api/Environment/AddEnvironment', {
            method: 'POST',
            body: JSON.stringify({ "projectId": this.props.project.id, "info": this.state.rowData }),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    var environments = scope.state.environments.slice(0);
                    var data = scope.state.rowData;
                    if (data.id) {
                        var index = environments.findIndex(e => e.id === data.id);
                        environments[index] = data;
                    }
                    else {
                        data.id = result.id;
                        environments.push(data);
                    }
                    scope.setState({ environments: environments });
                    scope.handleClose();
                }).catch((err) => console.log(err));
            }
        });
    };

    addEnvironment(data, resolve) {
        fetch('api/Environment/AddEnvironment', {
            method: 'POST',
            body: JSON.stringify({ "projectId": this.props.project.id, "info": data }),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    resolve();

                }).catch((err) => console.log(err));
            }
        });
        console.log(data);
        //resolve();
    }

    deleteEnvironment(data, resolve) {
        var scope = this;
        fetch('api/Environment/DeleteEnvironment', {
            method: 'POST',
            body: JSON.stringify({ "projectId": this.props.project.id, "info": data }),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    var environments = scope.state.environments.slice(0);
                    var index = environments.findIndex(e => e.id === data.id);
                    if (index !== -1) environments.splice(index, 1);
                    scope.setState({ environments: environments });
                    resolve();
                }).catch((err) => console.log(err));
            }
        });
    };

    render() {
        if (!this.props || !this.props.project) {
            return (<div></div>);
        }

        return (
            <div>
                <div className="expansion-internal-wrapper">
                    <MaterialTable
                        title=""
                        columns={this.state.environmentColumns}
                        data={this.state.environments}
                        editable={{
                            onRowDelete: oldData =>
                                new Promise(resolve => {
                                    this.deleteEnvironment(oldData, resolve);
                                }),
                        }}
                        actions={[
                            {
                                icon: 'add',
                                tooltip: 'Добавить среду',
                                isFreeAction: true,
                                onClick: (event) => this.setState({ "isAddEnvironmentOpen": true, "rowData": {} })
                            },
                            {
                                icon: 'edit',
                                tooltip: 'Редактировать',
                                isFreeAction: false,
                                onClick: (event, rowData) => {
                                    console.log(rowData); this.setState({ "isAddEnvironmentOpen": true, "rowData": rowData })
                                }
                            },
                            {
                                icon: 'clear',
                                tooltip: 'Flush redis',
                                isFreeAction: false,
                                onClick: (event, rowData) => {
                                    fetch('api/Environment/FlushRedis', {
                                        method: 'POST',
                                        body: JSON.stringify({ "projectId": this.props.project.id, "info": rowData }),
                                        headers: {
                                            'Content-Type': 'application/json'
                                        }
                                    }).then(function (res) {
                                        if (res.status === 401) {
                                        }
                                        else {
                                            res.json().then((result) => {
                                                alert(result.message);
                                            }).catch((err) => console.log(err));
                                        }
                                    });
                                }
                            },
                        ]}
                        options={{
                            actionsColumnIndex: -1,
                            grouping: true
                        }}
                    />
                </div>
                <Dialog
                    onClose={this.handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={this.state.isAddEnvironmentOpen}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                        Добавление новой среды
                    </DialogTitle>
                    <DialogContent dividers>
                        <AppBar position="static" color="default">
                            <Tabs
                                value={this.state.selectedTab}
                                onChange={this.handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                            >
                                <Tab label="Информация" />
                                <Tab label="Продукты" />
                            </Tabs>
                        </AppBar>
                        {this.state.selectedTab === 0 && <div className="card-inner-block">
                            <Typography>
                                <TextField required
                                    id="standard-required"
                                    label="Название"
                                    fullWidth
                                    margin="normal"
                                    value={this.state.rowData.name}
                                    onChange={this.handleRowDataChange('name')} />
                            </Typography>
                            <Typography>
                                <TextField required
                                    id="standard-required"
                                    label="URL"
                                    defaultValue="http://"
                                    fullWidth
                                    margin="normal"
                                    value={this.state.rowData.url}
                                    onChange={this.handleRowDataChange('url')} />
                            </Typography>
                            <Grid container spacing={2} justifyContent="center">
                                <Grid item sm={6}>
                                    <Typography>
                                        <TextField
                                            id="standard-select-environment-type"
                                            select
                                            label="Тип"
                                            value={this.state.rowData.environmentType}
                                            onChange={this.handleRowDataChange('environmentType')}
                                            helperText="dev,test,prod,pre"
                                            margin="normal"
                                            fullWidth
                                        >
                                            {this.state.environmentTypes.map(option => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Typography>
                                    <Typography>
                                        <TextField
                                            id="standard-select-currency"
                                            select
                                            label="Redis db"
                                            value={this.state.rowData.redisDB}
                                            onChange={this.handleRowDataChange('redisDB')}
                                            helperText=""
                                            margin="normal"
                                            fullWidth
                                        >
                                            {this.state.redisDBS.map(option => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Typography>
                                </Grid>
                                <Grid item sm={6}>
                                    <Typography>
                                        <TextField
                                            id="standard-select-currency"
                                            select
                                            label="SQL Server"
                                            value={this.state.rowData.sqlServer}
                                            onChange={this.handleRowDataChange('sqlServer')}
                                            helperText=""
                                            margin="normal"
                                            fullWidth
                                        >
                                            {this.state.sqlServers.map(option => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Typography>
                                    <Typography>
                                        <TextField required
                                            id="standard-required"
                                            label="Название БД"
                                            defaultValue=""
                                            fullWidth
                                            margin="normal"
                                            value={this.state.rowData.sqlDB}
                                            onChange={this.handleRowDataChange('sqlDB')} />
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Typography>
                                <TextField required
                                    id="standard-required"
                                    label="Бинарные файлы"
                                    defaultValue=""
                                    margin="normal"
                                    fullWidth
                                    value={this.state.rowData.binPath}
                                    onChange={this.handleRowDataChange('binPath')} />
                            </Typography>
                            <Typography>
                                <TextField required
                                    id="standard-required"
                                    label="Внешний адрес"
                                    defaultValue=""
                                    margin="normal"
                                    fullWidth
                                    value={this.state.rowData.externalUrl}
                                    onChange={this.handleRowDataChange('externalUrl')} />
                            </Typography>
                            <Typography>
                                <TextField required
                                    id="standard-required"
                                    label="Примечания"
                                    defaultValue=""
                                    margin="normal"
                                    fullWidth
                                    multiline
                                    value={this.state.rowData.notes}
                                    onChange={this.handleRowDataChange('notes')} />
                            </Typography>
                        </div>}
                        {this.state.selectedTab === 1 && <div className="card-inner-block">
                            <EnvironmentProductTable environmentId={this.state.rowData.id} />
                            </div>
                            }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleSave} color="primary">
                            Сохранить
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
});

export default ProjectEnvironments;